import { render } from "./serieEditar.vue?vue&type=template&id=0ae5d0b2"
import script from "./serieEditar.vue?vue&type=script&lang=js"
export * from "./serieEditar.vue?vue&type=script&lang=js"

import "./serieEditar.vue?vue&type=style&index=0&id=0ae5d0b2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__